module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box_header"
  }, [_c('label', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.title))]), _c('label', {
    staticClass: "plus",
    on: {
      "click": _vm.onItemAdd
    }
  }, [_c('span', {
    on: {
      "click": _vm.onItemAdd
    }
  }, [_vm._v(" Thêm kênh")])]), _c('label', {
    staticClass: "title-pc"
  }, [_vm._v(_vm._s(_vm.titleInfo))]), _c('div', {
    staticClass: "clearfix"
  })]), (!_vm.$isMobile()) ? _c('div', {
    staticClass: "box-table",
    staticStyle: {
      "max-height": "385px",
      "overflow-y": "scroll"
    },
    on: {
      "&scroll": function($event) {
        return _vm.handleScroll($event)
      }
    }
  }, [_c('mbTable', {
    attrs: {
      "centerColumns": ['name', 'action'],
      "data": _vm.channels,
      "columns": _vm.columns,
      "inlineFilter": true
    },
    on: {
      "onfilterbyname": _vm.filterbyname,
      "onItemEdit": _vm.onItemEdit,
      "onItemDelete": _vm.onItemDelete
    }
  })], 1) : _c('div', {
    staticClass: "card box-channel"
  }, [_c('div', {
    staticClass: "row-header"
  }, [_c('span', {
    staticClass: "label-header"
  }, [_vm._v("Tên kênh")]), _c('div', {
    staticClass: "field-header"
  }, [_c('input', {
    attrs: {
      "placeholder": "Tìm theo tên"
    },
    on: {
      "change": function($event) {
        return _vm.filterbynameX($event)
      }
    }
  })])]), (this.channels.length === 0) ? _c('div', {
    staticClass: "empty-data"
  }, [_c('span', [_vm._v("Không tìm thấy dữ liệu")])]) : _c('div', {
    staticClass: "list-item",
    staticStyle: {
      "overflow-y": "scroll"
    },
    on: {
      "&scroll": function($event) {
        return _vm.handleScrollX($event)
      }
    }
  }, _vm._l((_vm.channels), function(item) {
    return _c('div', {
      staticClass: "row-item"
    }, [_c('div', {
      staticClass: "row-data"
    }, [_c('span', {
      staticClass: "label-header"
    }, [_vm._v("Tên kênh")]), _c('div', {
      staticClass: "row-value"
    }, [_vm._v(_vm._s(item.name))])]), _c('div', {
      staticClass: "row-data"
    }, [_c('span', {
      staticClass: "label-header"
    }, [_vm._v("Ngày tạo")]), _c('div', {
      staticClass: "row-value"
    }, [_vm._v(_vm._s(_vm.formatDate(item.created_at)))])]), _c('div', {
      staticClass: "row-data"
    }, [_c('span', {
      staticClass: "label-header"
    }, [_vm._v("Ngày cập nhật")]), _c('div', {
      staticClass: "row-value"
    }, [_vm._v(_vm._s(_vm.formatDate(item.updated_at)))])]), _c('div', {
      staticClass: "row-data"
    }, [_c('span', {
      staticClass: "label-header"
    }), _c('div', {
      staticClass: "row-value"
    }, [_c('small', {
      on: {
        "click": function($event) {
          return _vm.onItemEdit(item)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": require('../../assets/images/faces/ic_edit.svg')
      }
    })]), _c('small', {
      on: {
        "click": function($event) {
          return _vm.onItemDelete(item)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": require('../../assets/images/theory/delete-24px.svg')
      }
    })])])])])
  }), 0)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-19720b68","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Channel/index.vue
// module id = 1495
// module chunks = 0